import { createSelector } from '@reduxjs/toolkit';
import { ESuburbanUtility } from '../../../../packages/JsonQuery';
import { selectElectricity, selectHasDrainage, selectHasGas, selectHasWater } from 'shared/selectors/jsonQuery';

export const selectSuburbanUtilitiesValue = createSelector(
  [selectElectricity, selectHasWater, selectHasGas, selectHasDrainage],
  (hasElectricity, hasWater, hasGas, hasDrainage) => {
    const suburbanUtilities: ESuburbanUtility[] = [];

    if (hasElectricity) {
      suburbanUtilities.push(ESuburbanUtility.Electricity);
    }

    if (hasDrainage) {
      suburbanUtilities.push(ESuburbanUtility.Drainage);
    }

    if (hasWater) {
      suburbanUtilities.push(ESuburbanUtility.Water);
    }

    if (hasGas) {
      suburbanUtilities.push(ESuburbanUtility.Gas);
    }

    return suburbanUtilities.length > 0 ? suburbanUtilities : [null];
  },
);
